export const ROLE_MEMBER = "ROLE_MEMBER";
export const ROLE_FACILITATOR = "ROLE_FACILITATOR";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_MOD = "ROLE_MOD";
